import { Link } from 'react-router-dom';

export default function Cancel() {
  return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center">
      <h1 className="text-3xl md:text-4xl font-bold">No worries — checkout cancelled.</h1>
      <p className="mt-6 text-slate-300 text-lg">
        Nothing was charged. DraftLion will be here whenever you're ready.
      </p>
      <div className="mt-8 flex justify-center gap-4">
        <Link to="/" className="btn-primary">Back to home</Link>
        <Link to="/setup" className="btn-secondary">See setup guide</Link>
      </div>
      <p className="mt-12 text-sm text-slate-400">
        Questions? <a className="text-amber-400 hover:text-amber-300" href="mailto:support@thedraftlion.com">support@thedraftlion.com</a>
      </p>
    </div>
  );
}
